import { firestoreAction } from 'vuexfire'
import _ from 'lodash'
import { notificationsCollection } from '@/firebase/data'
import {currentUserId} from '@/firebase/firebase'
import { timestamp } from '@/firebase/firebaseHelpers'
import { midnight, areEqual, formatyyymmdd, dateIn, addDays } from '@/helpers/date'
import * as DateHelper from '@/helpers/date'


const notificationDefaults = () => {
  return {
    read: false,
    title: '',
    message: '',
    icon: '',
    category: 'primary',
    actionName: '',
    index: 0
  }
}

export default {
  state: {
    notifications: [],
    notificationsDataLoaded: false
  },
  getters: {
    notificationsDataLoaded: (state) => state.notificationsDataLoaded,
    todayNotifications: (state) => _.reject(state.notifications, 'markAsDeleted'),
    unreadNotifications: (state) => _.reject(state.notifications, 'read'),
  },
  mutations: {
    setDataLoaded (state) {
      state.notificationsDataLoaded = true
    }
  },
  actions: {
    bindNotifications: firestoreAction(context => {
      return context.bindFirestoreRef(
        'notifications',
        notificationsCollection.where('uid', '==', currentUserId()),
        { wait: true }
      ).then(() => { context.commit('setDataLoaded') })
    }),
    ADMIN_ADD_NOTIFICATIONS (_, { notification }) {
      notificationsCollection.add(
        Object.assign(notificationDefaults(), notification, {
        uid: currentUserId(),
        createdAt: timestamp(),
      }))
    },
    ADD_INITIAL_NOTIFICATIONS_DELAYED ({dispatch}) {
      setTimeout(() => {
        dispatch("ADD_INITIAL_NOTIFICATIONS")
      }, 5000)
    },
    CREATE_ACHIEVEMENT (_, { actionName }) {
      notificationsCollection.add(
        Object.assign(notificationDefaults(), {
        uid: currentUserId(),
        createdAt: timestamp(),
        actionName: actionName,
        index: -1
      }))
    },
    // SECOND_DAY_NOTIFICATION () {
    //   notificationsCollection.add(
    //     Object.assign(notificationDefaults(), {
    //     uid: currentUserId(),
    //     createdAt: timestamp(),
    //     actionName: 'SecondDay',
    //     index: -1
    //   }))
    // },
    // fourDayStreak () {
    //   notificationsCollection.add(
    //     Object.assign(notificationDefaults(), {
    //     uid: currentUserId(),
    //     createdAt: timestamp(),
    //     actionName: 'FourDayStreak',
    //     index: -1
    //   }))
    // },
    // afterOneWeek () {
    //   notificationsCollection.add(
    //     Object.assign(notificationDefaults(), {
    //     uid: currentUserId(),
    //     createdAt: timestamp(),
    //     actionName: 'AfterOneWeek',
    //     index: -1
    //   }))
    // },
    // afterOneMonth () {
    //   notificationsCollection.add(
    //     Object.assign(notificationDefaults(), {
    //     uid: currentUserId(),
    //     createdAt: timestamp(),
    //     actionName: 'AfterOneMonth',
    //     index: -1
    //   }))
    // },
    ADD_INITIAL_NOTIFICATIONS (_) {
      notificationsCollection.add(
        Object.assign(notificationDefaults(), {
        uid: currentUserId(),
        createdAt: timestamp(),
        actionName: 'HelloAndWelcome',
        title: '',
        message: '',
        index: 0
      }))

      notificationsCollection.add(
        Object.assign(notificationDefaults(), {
        uid: currentUserId(),
        createdAt: timestamp(),
        actionName: 'FirstChapter',
        title: '',
        message: '',
        index: 1
      }))

      notificationsCollection.add(
        Object.assign(notificationDefaults(), {
        uid: currentUserId(),
        createdAt: timestamp(),
        actionName: 'AiCoaching',
        title: '',
        message: '',
        index: 2
      }))

      // notificationsCollection.add(
      //   Object.assign(notificationDefaults(), {
      //   uid: currentUserId(),
      //   createdAt: timestamp(),
      //   actionName: 'Academy',
      //   title: '',
      //   message: '',
      //   index: 2
      // }))

      // notificationsCollection.add(
      //   Object.assign(notificationDefaults(), {
      //   uid: currentUserId(),
      //   createdAt: timestamp(),
      //   actionName: 'DownloadApp',
      //   title: '',
      //   message: '',
      //   index: 3
      // }))

      // notificationsCollection.add(
      //   Object.assign(notificationDefaults(), {
      //   uid: currentUserId(),
      //   createdAt: timestamp(),
      //   actionName: 'DownloadApp',
      //   title: '',
      //   message: '',
      //   index: 3
      // }))
    },
    async REMOVE_ALL_NOTIFICATIONS ({ getters, state }) {
      console.log('REMOVE_ALL_NOTIFICATIONS')
      console.log(getters.todayNotifications)

       _.each(
        getters.todayNotifications,
        (n) => notificationsCollection.doc(n.id).delete()
      )

    },
    async UPDATE_NOTIFICATION (_, { notification, updateFields }) {
      console.info('UPDATE_NOTIFICATION', notification, updateFields)

      // if (updateFields.hasOwnProperty('deadline') || updateFields.hasOwnProperty('showList')) {
      //   console.log('removin list index')
      //   updateFields.listIndex = null
      // }

      notificationsCollection.doc(notification.id).update(updateFields)
    },

  }
}
